// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Splitter Bar Component */
:host {
  height: fit-content;
  width: fit-content;
  touch-action: none;
}

:host(:not([handle])) {
  cursor: var(--ids-cursor-move);
}

:host([disabled]:not([handle])) {
  cursor: inherit;
}

:host([axis=x]:not([disabled])) {
  cursor: var(--ids-cursor-resize-x);
}

:host([axis=y]:not([disabled])) {
  cursor: var(--ids-cursor-resize-y);
}

:host([is-dragging]:not([handle])) {
  cursor: var(--ids-cursor-grabbing);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-splitter/ids-splitter-bar.scss"],"names":[],"mappings":"AAEA,+BAAA;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,kCAAA;AAHF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as *;\n\n/* Ids Splitter Bar Component */\n\n// Inherit draggable cursor styles\n:host {\n  height: fit-content;\n  width: fit-content;\n  touch-action: none;\n}\n\n:host(:not([handle])) {\n  cursor: var(--ids-cursor-move);\n}\n\n:host([disabled]:not([handle])) {\n  cursor: inherit;\n}\n\n:host([axis='x']:not([disabled])) {\n  cursor: var(--ids-cursor-resize-x);\n}\n\n:host([axis='y']:not([disabled])) {\n  cursor: var(--ids-cursor-resize-y);\n}\n\n:host([is-dragging]:not([handle])) {\n  cursor: var(--ids-cursor-grabbing);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
